import "../CountCharacters/CountCharacters.css";

export default function CountCharacters(props){
    return(
        <div className="container">
            <span>{props.count}/{props.max}</span>
        </div>
    )
}